<script>
    import LibraryTags from '../../Models/LibraryTagModel'
    import SortableTable from '../SortableTable.svelte';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import Loader from '../Loader.svelte';
    import {notifier} from "@beyonk/svelte-notifications";

    let libraryTags = LibraryTags.getList();

    let fields = [
        {
            field: "name",
            name: "name",
            label: "Tag Name",
            type: "text",
            required: true
        },
        {
            field: "color",
            name: "color",
            label: "Tag Color",
            type: "select",
            required: true,
            choices: {
                static: [
                    {label: "Blue", value: "info"},
                    {label: "Green", value: "success"},
                    {label: "Yellow", value: "warning"},
                    {label: "Red", value: "danger"},
                ]
            },
            formatter: (field) => {
                return {
                    "info": "Blue",
                    "success": "Green",
                    "warning": "Yellow",
                    "danger": "Red"
                }[field]
            }
        }
    ]

    function addTag() {
        addFormModal({
            fields
        }).then((data) => {
            LibraryTags.createItem({name: data.name, color: data.color}).then(() => {
                notifier.success("Tag Added");
            })
        })
    }
</script>
<Loader loading={$libraryTags == undefined}>
    <div class="container is-fluid">
        <h1 class="title is-1">
            Tag Library
            <a href="#/QuestionLibrary" class="button is-pulled-right">Close</a>
        </h1>
        <SortableTable
            tableData={$libraryTags}
            sortFields={fields}
            showHideFields={false}
            paged={false}
        >
        <div slot="filterActions">
            <div class="buttons is-right">
                <button class="button is-success" on:click={addTag}>Add Tag</button>
            </div>
        </div>
        <div slot="footerActions">
            <div class="buttons is-right">
                <button class="button is-success" on:click={addTag}>Add Tag</button>
            </div>
        </div>

        </SortableTable>
    </div>
</Loader>